var _class;
import { observer } from "mobx-react";
import { Component } from "react";
import { withTranslation } from "react-i18next";
import isDefined from "../../../Core/isDefined";
import SelectableDimensions, { filterSelectableDimensions } from "../../../Models/SelectableDimensions/SelectableDimensions";
import Box from "../../../Styled/Box";
import SelectableDimension from "../../SelectableDimensions/SelectableDimension";
import { jsx as _jsx } from "react/jsx-runtime";
let SelectableDimensionSection = observer(_class = class SelectableDimensionSection extends Component {
  render() {
    const item = this.props.item;
    if (!SelectableDimensions.is(item)) {
      return null;
    }
    const selectableDimensions = filterSelectableDimensions(this.props.placement)(item.selectableDimensions);
    if (!isDefined(selectableDimensions) || selectableDimensions.length === 0) {
      return null;
    }
    return /*#__PURE__*/_jsx(Box, {
      displayInlineBlock: true,
      fullWidth: true,
      children: selectableDimensions.map((dim, _i) => /*#__PURE__*/_jsx(SelectableDimension, {
        id: "".concat(item.uniqueId, "-").concat(dim.id),
        dim: dim
      }, "".concat(item.uniqueId, "-").concat(dim.id, "-fragment")))
    });
  }
}) || _class;
export default withTranslation()(SelectableDimensionSection);